<button
	(click)="uploadCarriersDialog()"
	*ngIf="useButton && !fullWidth"
	color="primary"
	mat-raised-button
>
	{{ text }}
</button>

<button
	(click)="uploadCarriersDialog()"
	*ngIf="useButton && fullWidth"
	color="primary"
	fxFlex="100"
	mat-raised-button
>
	{{ text }}
</button>

<span (click)="uploadCarriersDialog()" *ngIf="useText" class="link primary-text">{{ text }}</span>

<button
	(click)="uploadCarriersDialog()"
	*ngIf="useMenuButton"
	class="{{ textClass }}"
	mat-menu-item
>
	{{ text }}
</button>
